import React from 'react'
import { checkTranslation, chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import CustomLoader from '../../components/CustomLoader';
import StagesManager from '../../components/StagesManager';
import VoiceCallsHistory from './VoiceCallsHistory';
import VideoCallsHistory from './VideoCallsHistory';
import RoomsHistory from './RoomsHistory';


class History extends React.Component {
    state = {

        isLoader: false,
        currentPage: 'voice',

        tabs: [
            { key: "voice", name: "{{lang}}rooms.Voice Calls", icon: "/assets/icons/rooms/voicecall.svg" },
            { key: "video", name: "{{lang}}rooms.Video Calls", icon: "/assets/icons/rooms/videocall.svg" },
            { key: "rooms", name: "{{lang}}rooms.Rooms-history", icon: "/assets/icons/rooms/roomcall.svg" },
        ]
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }


    changePage = (prop) => {
        this.setState({ currentPage: prop.key })
        this.stageManager.changeStage(prop.key)
    }




    render() {
        return (
            <div className=' window-content-radius scroll-no-scrollbar h-100' style={{}}>
                <div className='w-100  position-sticky top-0 ' style={{ backgroundColor: "#f6f6f6", zIndex: 10 }} >
                    <div className='flexcc tab-purple-btn br-10' >
                        {this.state.tabs.map((prop, index) => {
                            return (
                                <button style={{ width: "150px" }} key={index} className={'flexcc py-1 br-8 ' + (this.state.currentPage == prop.key ? ' selected m-1 ' : ' unselected m-1 ')} onClick={() => this.changePage(prop)}>
                                    <img className='mrd-2' src={prop.icon} />
                                    <p className='prd-3'>{checkTranslation(prop.name)}</p>
                                </button>
                            )
                        })}
                    </div>
                </div>
                {/* <div> */}
                    <StagesManager ref={el => this.stageManager = el}  className={'flex-1'} fast={true}>
                        <VoiceCallsHistory width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'voice'} />
                        <VideoCallsHistory width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'video'} />
                        <RoomsHistory width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'rooms'} />
                    </StagesManager>
                {/* </div> */}
            </div>
        )
    }
}

export default History;